export const CircularLoader = () => (
  <span className="ml-2 inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin align-middle" />
);
